import type { Building } from '../types/Building';

// Import and export the buildings data with real building images
import buildingsJson from '../../data/buildings.json';

export const buildings: Building[] = buildingsJson as Building[];